import { createAction } from 'redux-actions';
import { SET_SCOPE } from '../../constants';
export var setScope = createAction(SET_SCOPE);